import { Tooltip } from "@/components/Tooltip";
import type { FC } from "react";

export const OCU: FC<{ label?: string }> = ({ label = "OCU" }) => {
    return (
        <Tooltip
            content={
                "Ona Compute Units (OCUs) represent credits that are used for environment runtime and agent conversations"
            }
            inverted={false}
            usePortal={true}
        >
            <span className="cursor-help underline decoration-dotted decoration-1 underline-offset-2">{label}</span>
        </Tooltip>
    );
};
export const OCUs: FC = () => {
    return <OCU label="OCUs" />;
};
